<template>
  <div class="box">
    <div class="container">
      <div id="wraps" style="padding:16px;padding-bottom: 0px!important;position: relative">
        <div>
          <div class="title">
            <div class="carNoDiv">
              <input id="areaName" type="search" placeholder="请输入要搜索的地址"/></div>
          </div>
          <div id="allmap"
               style="overflow:hidden;zoom:1;position:relative;height: 590px;width:99.5%;border: 2px solid #DCDFE6">
            <div id="map"
                 style="height:590px;-webkit-transition: all 0.5s ease-in-out;transition: all 0.5s ease-in-out;"></div>
          </div>
        </div>
      </div>
      <div class="center">
        <div id="wrap" style="padding:10px;">
          <div style="padding-left: 5px;padding-right: 8px;">
            <div class="head-common">
              <div class='massLoss-list'>
                <div class='nav'>
                  <el-form :model='searchForm' label-width='90px' :inline='true'
                           class='demo-form-inline flex1' ref='searchForm'>
                    <el-form-item label='区域名称：'>
                      <el-input v-model='searchForm.regionName' size='mini'
                                placeholder='请输入区域名称'></el-input>
                    </el-form-item>
                    <el-form-item label='围栏名称：'>
                      <el-input v-model='searchForm.fenceName' size='mini'
                                placeholder='请输入围栏名称'></el-input>
                    </el-form-item>
                    <el-form-item label='停用状态：'>
                      <el-select v-model='searchForm.isEnable' filterable size='mini'
                                 placeholder='请选择停用状态'>
                        <el-option label='全部' value=''></el-option>
                        <el-option label='是' value='1'></el-option>
                        <el-option label='否' value='0'></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label='时间：' label-width='60px'>
                      <el-date-picker v-model='transmissionDate' type='daterange' align='right'
                                      size='mini' range-separator='-' value-format='yyyy-MM-dd'
                                      start-placeholder='开始日期' end-placeholder='结束日期'>
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
                      <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
                      <el-button size='small' type='danger' @click='btnClick("delete")'>删除
                      </el-button>
                      <el-button size='small' type='warning' @click='btnClick("batchOutage")'>
                        批量停用
                      </el-button>
                      <el-button size='small' type='success' @click='btnClick("batchEnable")'>
                        批量启用
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div class='content'>
                  <div class='tableContainer'>
                    <el-table v-loading='tableLoading' :data='tableData' style='width: 100%'
                              ref="table" border
                              :header-cell-style='headerCellStyle'
                              @selection-change='selectionChange'
                              :row-style="rowStyle">
                      <el-table-column type='selection' align='center' width='50'/>
                      <el-table-column prop='regionName' label='区域名称' align='center'
                                       min-width='100'/>
                      <el-table-column prop='fenceName' label='围栏名称' align='center'
                                       min-width='100'/>
                      <el-table-column prop='createTime' label='创建时间' align='center'
                                       min-width='100'/>
                      <el-table-column label='操作' width='450' align='center' fixed='right'>
                        <template slot-scope='scope'>
                          <el-button size="mini" type="primary"
                                     @click='detailClick(scope.row.id)'>详情
                          </el-button>
                          <el-button size="mini" class="searchBtn"
                                     @click='view(scope.row)'>查看电子围栏
                          </el-button>
                          <el-button size="mini" type="danger"
                                     @click='btnClick("deleted", scope.row)'>删除
                          </el-button>
                          <el-button size="mini" v-if='scope.row.isEnable === 0' type="warning"
                                     @click='btnClick("disabled", scope.row)'>停用
                          </el-button>
                          <el-button size='mini' v-if='scope.row.isEnable === 1' type='success'
                                     @click='btnClick("enable", scope.row)'>启用
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class='paginationContainer'>
                    <el-pagination background :page-sizes='[10, 20, 30, 40]'
                                   layout='total, sizes, prev, pager, next, jumper'
                                   :total='total'
                                   @size-change='contractSizeChange'
                                   @current-change='contractCurrentChange'
                                   :current-page.sync='searchForm.page'
                                   :page-size='searchForm.rows'/>
                  </div>
                </div>
                <add-electronicFence @success="searchBtn" ref="addRef"/>
                <detail-info ref="detailInfo"  />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  electronicFenceDelete,
  getPage,
  updateStatus
} from "@/service/DevOps";
import addElectronicFence from "@/views/DevOps/electronicFence/components/addElectronicFence.vue";
// import {initMap, drawManager, searchAntistop, showFence, clearAll} from '../../../service/fence';
import detailInfo from "@/views/DevOps/electronicFence/components/detailInfo.vue"
export default {
  components: {addElectronicFence,detailInfo},
  name: "List",
  data() {
    return {
      searchForm: {
        regionName: '',
        fenceName: '',
        regionId: '',
        fenceId: '',
        longitude: '',
        latitude: '',
        longLatitude: '',
        isEnable: '',
        isDelete: '',
        createTime: '',
        status: '',
        page: 1,
        rows: 10,
      },
      transmissionDate: [],
      defaultSearchForm: {},
      tableLoading: false,
      tableData: [],
      selectTableData: [],
      selectedData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
      placeholderName: '请选择基地名称',
      //电子围栏坐标点
      isMultiple: false,
      toolTipValue: '',
      baseMultipleInfos: [],
      oldOptions: [],
      overlays: [],
      isSelect: false,
      overlaycomplete: '',
      drawingManager: '',
      map: '',
      allMapHeight: '',
      isdiaabled: false,
      myValue: '',
      fenceData: {},
      recrivePlaceInfo: '',
      //电子围栏样式(画电子围栏)
      styleOptions: {
        strokeColor: "red",    //边线颜色。
        fillColor: "",      //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 3,       //边线的宽度，以像素为单位。
        strokeOpacity: 0.8,	   //边线透明度，取值范围0 - 1。
        fillOpacity: 0.6,      //填充的透明度，取值范围0 - 1。
        strokeStyle: 'dashed' //边线的样式，solid或dashed。
      },
      serarchInfo: {
        fenceName: '',
        fenceType: '',
        baseName: '',
        baseCode: '',
        baseType: '0'
      },
      selectBaseType: [
        {
          "code": '0', "name": '基地'
        },
        {
          "code": '1', "name": '中储'
        }
      ],
      fence: {
        id:'',
        name:'',
        type:'',
        shape:'',
        radius:'',
        points:'',
        baseCode:'',
        recriveCode:'',
        recrivePlaceName:''
      },
      dialogTitle: '',
      dialogVisible: false,
      inputDisabled: true,
      formClass: '',
      btnDisabled: false,
      dialogDeleteVisible: false,
      dialogDeleteTitle: false,
      baseInfos: [],
      deleteFence: {
        id: '',
        remark: ''
      },
    }
  },
  mounted: function () {
    let point = {};
    point.lng = 106.538553;
    // initMap();
    //画电子围栏
    // drawManager();

    // searchAntistop();
    //ptInPolygon(point);
    //将方法暴露出去让外部可以访问
    window.showDialog = (fenceData) => {
      //调新增弹窗
      this.addBtn(fenceData)
      console.log(fenceData)
    }
  },
  methods: {
    btnClick(str, row) {
      switch (str) {
        case 'delete':
          if (this.selectedData.length === 0) return this.$message.warning('请选择数据后删除！');
          const deleteIds = this.selectedData.map(item => item.id)
            .join(',');
          this.fenceDelete(deleteIds);
          break;
        case 'batchOutage':
          if (this.selectedData.length === 0) return this.$message.warning('请选择数据后停用！');
          const ids = this.selectedData.map(item => item.id).join(',');
          this.fenceDeactivate(ids, str);
          break;
        case 'batchEnable':
          if (this.selectedData.length === 0) return this.$message.warning('请选择数据后启用！');
          const enabletIds = this.selectedData.map(item => item.id).join(',');
          this.fenceDeactivate(enabletIds, str);
          break;
        case 'enable':
          this.fenceDeactivate(row.id, str);
          break;
        case 'disabled':
          this.fenceDeactivate(row.id, str);
          break;
        case 'deleted':
          this.fenceDelete(row.id, str);
          break;
      }
    },
    //查询
    searchBtn() {
      //清除所有覆盖物
      // clearAll();
      this.page = 1;
      this.getTableList();
    },
    //分页查询电子围栏
    async getTableList() {
      this.tableLoading = true;
      const obj = {
        regionName: this.searchForm.regionName,
        fenceName: this.searchForm.fenceName,
        regionId: this.searchForm.regionId,
        fenceId: this.searchForm.fenceId,
        longitude: this.searchForm.longLatitude,
        latitude: this.searchForm.longLatitude,
        isEnable: this.searchForm.isEnable,
        isDelete: this.searchForm.isDelete,
        createTime: this.searchForm.createTime,
        timeStart: this.transmissionDate[0] ? this.transmissionDate[0] : '',
        timeEnd: this.transmissionDate[1] ? this.transmissionDate[1] : '',
        page: 1,
        rows: 10,
      }
      const res = await getPage(obj)
      this.tableLoading = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.tableData = res.data.records;
      this.total = res.data.total;
    },
    //重置
    resetBtn(){
      this.searchForm.regionName = ''
      this.searchForm.fenceName = ''
      this.searchForm.isEnable = ''
      this.transmissionDate = ''
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableList();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableList();
    },
    //新增
    addBtn(fenceData) {
      this.$refs.addRef.dialogOpen(fenceData)
    },
    /**
     * 删除
     * @param id 当前选中数据 id
     */
    fenceDelete(ids) {
      this.$confirm('确认删除当前选中数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await electronicFenceDelete({ids});
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.clearSelectedData();
        });
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    selectionChange(selectionRow) {
      this.selectedData = selectionRow;
    },
    clearSelectedData() {
      this.selectedData = [];
      this.$refs.table.clearSelection();
      this.searchBtn();
    },
    /**
     * 批量启用/启用/停用
     * @param ids 当前选中数据 id
     * @param str 区分启用停用
     */
    fenceDeactivate(ids, str) {
      const isEnable = str === 'batchOutage' || str === 'disabled' ? 1 : 0;
      this.$confirm(`确认${str === 'batchOutage' || str === 'disabled' ? '停用' : '启用'}当前选中数据？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await updateStatus({
            ids,
            isEnable,
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.clearSelectedData();
        });
    },
    //查看
    view(row){
      this.btnDisabled = true;
      this.showDialogInfo(row);
    },
    //显示对话框内容
    showDialogInfo(row) {
      if (row && row.longLatitude){
        let fencePoints;
        if (row.longLatitude.indexOf("[") === -1) {
          fencePoints = row.longLatitude.replace("{", "[{").replace("}", "}]");
        } else {
          fencePoints = row.longLatitude.replace("[", "[").replace("]", "]");
        }
        fencePoints = JSON.parse(fencePoints);
        // showFence(row.fenceShape, fencePoints, row.fenceRadius);
        // drawManager();
        //圆形
        if (row.fenceShape === '2') {
          this.fence.shape = 'circle';
        } else {
          //多边形
          this.fence.shape = 'Polygon';
        }
        this.fence.radius = row.fenceRadius;
      }
    },
    //详情
   async detailClick(id){
      this.$refs.detailInfo.detailOpen(id)
    }
  }
}
</script>


<style lang='scss' scoped>


#allmap {
  width: 100%;
  height: 500px;
  overflow: hidden;
}

#result {
  width: 100%;
  font-size: 12px;
}

dl, dt, dd, ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
}

p {
  font-size: 12px;
}

dt {
  font-size: 14px;
  font-family: "微软雅黑";
  font-weight: bold;
  border-bottom: 1px dotted #000;
  padding: 5px 0 5px 5px;
  margin: 5px 0;
}

dd {
  padding: 5px 0 0 5px;
}

li {
  line-height: 28px;
}

.header {
  text-align: left;
  height: 53px !important;
}

.title {
  position: absolute;
  left: 38px;
  top: 29px;
  z-index: 100;
  background-image: url(../../../assets/images/searchMap.png);
  width: 280px;
  height: 32px;
  background-size: 100% 100%;
}

.title .carNoDiv {
  width: 100%;
  height: 100%;
  float: left;
}

.title input {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  color: #fff;
  padding-left: 2%;
}

.title .search {
  width: 20%;
  height: 100%;
  cursor: pointer;
  float: left;
}

#top {
  margin: 0px;
}

.anchorBL a {
  display: none;
}

.BMap_cpyCtrl {
  display: none;
}

input[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
}

.footer {
  display: flex;
  align: right;
  justify-content: space-between;
  padding-top: 20px;
  float: right;
}

.fenceForm {
  pointer-events: none;
}

.massLoss-list {
  padding: 20px 15px 0 25px;
  height: 100%;

  .nav {
    display: flex;
    overflow: hidden;

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }

      .el-date-editor--daterange.el-input__inner {
        width: 230px
      }
    }
  }

  ::v-deep .detail {
    .el-form-item {
      margin-bottom: 2px;

      .el-form-item__label {
        font-weight: 700;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;
    padding: 10px 0 20px 20px;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(249, 166, 6);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }


      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding-right: 20px;
      }
    }
  }


  ::v-deep .add {
    .el-form-item__label {
      font-weight: 700;
    }

    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          .el-form-item {
            .el-form-item__error {
              left: 40px;
            }

            margin-bottom: 5px;

            .el-form-item__label {
              // width: 150px !important;
            }

          }

        }

        .repair {
          .el-input {
            width: 80%;
          }

          .el-form-item {
            .el-form-item__error {
              padding-top: 0px;
            }

            margin-bottom: 7px;
          }

          .el-upload-list__item {
            width: 100px;
            height: 100px;
          }

          .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
          }

          /*display: none;*/
          .imgUp {
            display: flex;
            flex-direction: column;

            .imgLength {
              display: flex;
              align-items: center;
              width: 100%;

              span {
                margin-left: auto;
                color: rgb(183, 183, 183);
                font-size: 16px;
              }
            }
          }
        }

      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }

  }

}

.tableContainer {
  margin: 10px 0 30px 0;
}

.exportButton {
  span {
    color: rgba(51, 136, 255, 1);
    font-size: 14px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
